export default __webpack_public_path__ + "static/media/medica.af006ad7.png";